import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_URL;
const apiUrl = '/checklist'; // Modify this based on your API endpoint

export const getChecklistByTemplate = (templateId) => {
  return axios.get(`${BASE_URL}${apiUrl}/${templateId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.response?.data?.message || 'Failed to fetch checklist');
    });
};

export const createChecklistItem = ({ templateId, question }) => {
  return axios.post(`${BASE_URL}${apiUrl}/${templateId}`, { question })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.response?.data?.message || 'Failed to add question');
    });
};

export const deleteChecklistItem = (itemId) => {
  return axios.delete(`${BASE_URL}${apiUrl}/${itemId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.response?.data?.message || 'Failed to delete question');
    });
};
